/** Utility di formattazione number / currency / duration. */

export function formatEuro(n: number, fractionDigits = 0): string {
  if (!Number.isFinite(n)) return '—';
  return new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(n);
}

export function formatNumber(n: number, fractionDigits = 0): string {
  if (!Number.isFinite(n)) return '—';
  return new Intl.NumberFormat('it-IT', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(n);
}

export function formatHours(n: number, fractionDigits = 0): string {
  if (!Number.isFinite(n)) return '—';
  return new Intl.NumberFormat('it-IT', {
    style: "unit",
    unit: "hour",
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(n);
}

export function formatMonths(months: number): string {
  if (!Number.isFinite(months)) return 'Mai (ROI negativo)';
  if (months < 1) return '< 1 mese';
  if (months < 12) return `${months.toFixed(1)} mesi`;
  const years = months / 12;
  return `${years.toFixed(1)} anni (${months.toFixed(0)} mesi)`;
}

export function formatPercent(fraction: number, fractionDigits = 1): string {
  return `${(fraction * 100).toFixed(fractionDigits)}%`;
}
